import { Stack } from "@mui/material";

import LoadingSpinner from "./LoadingSpinner";

export default function LoadingSpinnerPage() {
  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 24,
      }}
    >
      <LoadingSpinner />
    </Stack>
  );
}
